"use client";
import React, { useState, useEffect } from "react";

export default function Header() {
  const messages = [
    "✨ Go Prepaid & Save! Enjoy FREE shipping on prepaid orders. COD above ₹2000? Enjoy FREE shipping. 🚚💳",
  ];

  const [currentMessage, setCurrentMessage] = useState("");
  const [messageIndex, setMessageIndex] = useState(0);
  const [charIndex, setCharIndex] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);

  useEffect(() => {
    const currentText = messages[messageIndex];

    if (!isDeleting && charIndex < currentText.length) {
      // Typing Effect
      setTimeout(() => {
        setCurrentMessage(currentText.slice(0, charIndex + 1));
        setCharIndex((prev) => prev + 1);
      }, 50);
    } else if (!isDeleting && charIndex === currentText.length) {
      // Pause after typing is complete
      setTimeout(() => setIsDeleting(true), 2000);
    } else if (isDeleting && charIndex > 0) {
      // Deleting Effect
      setTimeout(() => {
        setCurrentMessage(currentText.slice(0, charIndex - 1));
        setCharIndex((prev) => prev - 1);
      }, 50);
    } else if (isDeleting && charIndex === 0) {
      // Move to the next message
      setIsDeleting(false);
      setMessageIndex((prev) => (prev + 1) % messages.length);
    }
  }, [charIndex, isDeleting, messageIndex, messages]);

  return (
    <header className='py-2 px-3 text-center bg-header'>
      <p className="fw-normal typing-text">{currentMessage || "\u00A0"}</p>
    </header>
  );
}
